import { useMemo } from 'react';
import { ID } from 'shared/types/id';

import { useGoals } from './use-goals';

export const useGoalById = (id?: ID) => {
  const goals = useGoals();

  return useMemo(() => goals.find((goal) => goal.id === id), [goals, id]);
};
